import React from "react"
import styled from "styled-components"
import Arrow from "../../images/arrow.inline.svg"
import { AppFunctionComponent, Quote as QuoteType } from "../../types"
import Section from "./sections/section.component"
import { ArrowsWrapper } from "./slider.component"
import { FullSizeSliderNavigation, Slider, Slides } from "./slider/slider"
import QuoteResolver from "../../resolvers/quote/quote.resolver"
import { ScrollAnchor } from "./sections/custom/innovation-lab-form/innovation-lab.component"

const SliderWrapper = styled(Slider)`
  display: grid;
  grid-template-areas: "Quote";
  height: 100%;
`

const SlidesWrapper = styled(Slides)`
  grid-area: Quote;
  max-height: 100%;
`

export const ArrowIcon = styled(Arrow)`
  height: 15px;
  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    height: 22px;
  }
`

const Arrows = styled(ArrowsWrapper)`
  height: calc(100% - 40px);
  max-width: 1120px;

  @media (min-width: 440px) {
    height: calc(100% - 40px);
  }
`

const QuoteSlide = styled((props) => <QuoteResolver {...props} />)`
  min-height: 370px;

  p {
    /* Styles for truncating text */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    /* to specify the number of lines you want to display */
    -webkit-line-clamp: 13;
    overflow: hidden;
  }

  @media (min-width: 540px) {
    min-height: 270px;
  }

  @media (min-width: 768px) {
    min-height: 120px;
    -webkit-line-clamp: 4;
  }
`
interface Props {
  slides: QuoteType[]
  title?: string
  anchorId?: string
}

const QuoteSlider: AppFunctionComponent<Props> = ({
  className = "",
  slides,
  title = "Quote slider",
  anchorId,
}) => {
  return (
    <Section className={className}>
      <ScrollAnchor id={anchorId} />
      <SliderWrapper title={title}>
        <SlidesWrapper>
          {slides.map((slide, index) => (
            <QuoteSlide {...slide} key={index} />
          ))}
        </SlidesWrapper>
        <Arrows>
          <FullSizeSliderNavigation />
        </Arrows>
      </SliderWrapper>
    </Section>
  )
}

export default QuoteSlider
